export default "__VITE_ASSET__BxXfbpHN__"